import React from "react";
import styles from "./CardHeaderPage.module.scss";

const CardHeaderPage = ({ text, textAlign,backgroundColor}) => {
  return <div className={styles.container} style={{textAlign:textAlign,backgroundColor:backgroundColor}}>{text}</div>;
};

export default CardHeaderPage;
